RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TableContainer = Marionette.LayoutView.extend({
        regions: {
            tableContainer: '.x-table-container'
        },

        template: '#tableContainerTemplate',

        sortableClassName: 'sortable pointer',
        sortedColumnClassName: 'sorted',
        sortedAscendingClassName: 'sort-asc',
        sortedDescendingClassName: 'sort-desc',
        sortUsageMetric: 'SeoOverviewSortedDetailsTable',
        masterRowClass: 'active',
        activeSortOrder: -1,

        initialize: function () {

            const me = this;
            _.extend(me, _.pick(me.getOption('config') || {}, 'activeSort', 'activeSortOrder', 'sortUsageMetric'));
        },

        serializeData: function () {
            const me = this;
            const isTableResponsive = Boolean(me.getOption('tableResponsive'));
            return {
                tableContainerClass: (isTableResponsive ? 'table-responsive' : '')
            };
        },

        onRender: function () {

            const me = this;

            if (!me.initialSortRun) {

                me.initialSort();
            }

            me.initializeTable();
        },

        getDefaultSort: function (property) {

            return function (order, a, b) {

                const valueA = _.get(a, property);
                const valueB = _.get(b, property);

                if (!_.exists(valueA)) {

                    return (!_.exists(valueB) ? 0 : -1 * order);
                }

                if (!_.exists(valueB)) {

                    return Number(order);
                }

                return (_.isString(valueA) ? valueA.localeCompare(valueB) : valueA - valueB) * order;
            };
        },


        // Sort the initial table with the provided activeSort and
        // activeSortOrder
        initialSort: function () {

            const me = this;

            me.initialSortRun = true;

            if (!me.activeSort) {

                return;
            }

            const activeSort = me.activeSort;
            const config = me.getOption('config');
            const masterColumns = _.result(config, 'masterColumns');
            const columns = (masterColumns || _.result(config, 'columns'));

            const column = _.find(columns, function (candidate) {

                return _.includes([candidate.sortKey, candidate.sort, candidate.property], activeSort);
            });

            if (!column) {

                return;
            }

            const sortType = (masterColumns ? (column.empty ? 'sub' : 'master') : null);
            const sortProperty = (column.sort || column.property);

            me.sortByType(sortType, sortProperty, me.activeSortOrder);
        },

        // TODO TableContainer should accept a collection of models for drawing
        // the table instead of expecting JSON
        columnsToRow: function (model, columns, config, index) {
            config = config || {};
            const row = {};
            const me = this;

            if (_.isFunction(model)) {

                return {
                    columns: model()
                };
            }

            const sortedColumnClassName = me.getOption('sortedColumnClassName');

            row.data = model;

            row.columns = _.map(columns, function (column) {

                const classNames = [];

                if (column.sort && (column.property && me.activeSort === column.property) ||
                    (column.sortKey && me.activeSort === column.sortKey)) {

                    classNames.push(sortedColumnClassName);
                }

                if (column.cellClassName) {

                    if (_.isFunction(column.cellClassName)) {

                        classNames.push(column.cellClassName(model, column.property));
                    } else {

                        classNames.push(column.cellClassName);
                    }
                }

                let attributes;

                if (column.cellAttributes) {

                    attributes = (_.isFunction(column.cellAttributes) ?
                        column.cellAttributes(model) : column.cellAttributes);
                }

                let value;
                let getValue;

                if (!column.empty) {

                    if (_.isFunction(column.value)) {

                        getValue = column.value;
                    } else if (_.has(column, 'property')) {

                        getValue = _.partial(_.get, _, column.property, column.default);
                    } else {

                        getValue = _.partial(_.identity, column.value);
                    }

                    value = _.bind(getValue, column.scope, model, index);
                }

                return {
                    data: model,
                    value: value,
                    attributes: attributes,
                    cellView: column.cellView,
                    formatter: column.formatter,
                    className: classNames.join(' '),
                    property: (column.sortKey || column.property)
                };
            });

            if (config.onRowClick && _.isFunction(config.onRowClick)) {
                row.onClick = _.bind(config.onRowClick, null, model);
            }

            row.rowClass = (_.isFunction(config.rowClass) ? config.rowClass(model) : config.rowClass);

            return row;
        },

        sortByType: function (type, sortProperty, sortOrder) {
            const me = this;
            const sortable = me.model.get('data');
            let sortFn = sortProperty;

            if (!_.isFunction(sortFn)) {
                sortFn = me.getDefaultSort(sortProperty);
            }

            const sort = _.partial(sortFn, sortOrder);

            if (!type) {

                sortable.sort(sort);
            } else if (type === 'master') {

                sortable.sort(function (a, b) {

                    return sort(_.head(a), _.head(b));
                });
            } else {

                _.invokeMap(sortable, 'sort', sort);
            }
        },

        sortBySortProperty: function (sort, sortProperty, sortOrder) {

            const me = this;

            me.activeSort = sortProperty;
            me.activeSortOrder = sortOrder;

            const table = me.tableContainer.currentView;
            const comparator = _.isFunction(sort) ? sort : me.getDefaultSort(sortProperty);

            table.sort(_.partial(comparator, sortOrder));

            table.children.invoke('updateSortedColumns', {
                property: sortProperty,
                sortOrder: sortOrder,
                className: me.getOption('sortedColumnClassName'),
                ascendingClassName: me.sortedAscendingClassName,
                descendingClassName: me.sortedDescendingClassName
            });
        },

        setColumns: function (columns) {
            const me = this;

            const config = me.getOption('config');
            _.set(config, 'columns', columns);
        },

        buildSortFunction: function (sort, sortType, key) {

            const me = this;

            if (!sort) {

                return null;
            }

            let order = -1;

            if (me.activeSort === sort) {

                order = (me.activeSortOrder || -1);
            }

            const defaultSortOrder = order;

            const sortUsageMetric = me.getOption('sortUsageMetric');

            return function () {

                const sortKey = (key ? key : sort);

                order = (me.activeSort === sortKey ? order * -1 : defaultSortOrder);

                if (!sortType) {

                    me.sortBySortProperty(sort, key, order);
                } else {
                    me.activeSort = sortKey;
                    me.activeSortOrder = order;

                    me.sortByType(sortType, sort, order);
                    me.render();
                }

                me.trigger('change:option', {
                    sortOrder: order,
                    sortProperty: sortKey
                });

                me.triggerMethod('sort', sortKey, order);

                if (sortUsageMetric) {

                    RivalIQ.execute('tracking:push:auth', sortUsageMetric, {
                        order: order,
                        property: sortKey
                    });
                }
            };
        },

        initializeTable: function () {
            const me = this;
            const model = me.model;
            let header = null;
            let body = null;
            let table = model.get('table');
            const config = me.getOption('config') || {};
            const columns = config.columns;

            if (config.subColumns) {
                header = _.map(config.header, function (column, idx) {
                    let className = '';
                    let onClick = column.sort;
                    const isMasterColumn = !config.masterColumns[idx].empty;

                    if (_.isString(column.sort)) {
                        className = me.sortableClassName;
                        onClick = me.buildSortFunction(column.sort,
                            (isMasterColumn ? 'master' : 'sub'), (column.sortKey || column.property));
                    }

                    if (column.sort && me.activeSort === column.sort) {
                        className += ` ${me.sortedColumnClassName}`;
                        className += ` ${(me.activeSortOrder > 0) ? me.sortedAscendingClassName : me.sortedDescendingClassName}`;
                    }

                    if (column.className) {
                        if (_.isFunction(column.className)) {
                            className += ` ${column.className()}`;
                        } else {
                            className += ` ${column.className}`;
                        }
                    }

                    const attributes = {};
                    const tooltip = me.getTooltipForHeaderColumn(column);

                    if (tooltip) {
                        attributes.title = tooltip;
                    }

                    return _.extend({
                        onClick: onClick,
                        value: column.value,
                        className: $.trim(className),
                        attributes: attributes
                    });
                });

                const masterColumns = config.masterColumns;
                const subColumns = config.subColumns;

                body = [];
                model.get('data').forEach(function (master) {
                    const masterRow = me.columnsToRow(master[0], masterColumns, config);
                    masterRow.rowClass = me.getOption('masterRowClass');
                    body.push(masterRow);
                    let firstSub = null;
                    let lastSub = null;
                    master.forEach(function (model) {
                        const subRow = me.columnsToRow(model, subColumns);
                        if (!firstSub) {
                            firstSub = subRow;
                        }
                        lastSub = subRow;
                        subRow.rowClass = 'x-table-sub-row';
                        body.push(subRow);
                    });
                    if (firstSub) {
                        firstSub.rowClass += ' x-table-first-sub-row';
                        lastSub.rowClass += ' x-table-last-sub-row';
                    }
                });
            } else if (config.columns) {
                // first generate the header cells
                header = _.map(columns, function (column) {
                    let className = '';

                    let onClick = column.sort;

                    // find sort function
                    if (column.onSort) {
                        onClick = _.bind(column.onSort, me);
                    } else if (column.sort) {
                        onClick = me.buildSortFunction(column.sort,
                            null, (column.sortKey || column.property));
                    }

                    // add sort classes
                    if (column.onSort || column.sort) {
                        className = me.sortableClassName;

                        if ((column.property && me.activeSort === column.property) || (column.sortKey && me.activeSort === column.sortKey)) {
                            className += ` ${me.sortedColumnClassName}`;
                            className += ` ${(me.activeSortOrder > 0) ? me.sortedAscendingClassName : me.sortedDescendingClassName}`;
                        }
                    }


                    if (column.className) {
                        if (_.isFunction(column.className)) {
                            className += ` ${column.className()}`;
                        } else {
                            className += ` ${column.className}`;
                        }
                    }

                    const attributes = _.extend({}, column.attributes);
                    const tooltip = me.getTooltipForHeaderColumn(column);

                    if (tooltip) {
                        attributes.title = tooltip;
                    }

                    return {
                        onClick: onClick,
                        value: column.name,
                        className: $.trim(className),
                        attributes: attributes,
                        property: (column.sortKey || column.property)
                    };
                });

                // then generate the body rows
                let data = model.get('data');
                if (data) {
                    data = (data.toArray ? data.toArray() : data);
                }

                body = _.map(data, function (model, i) {
                    return me.columnsToRow(model, columns, config, i);
                });
            }

            if (header || body) {

                if (body.length === 0) {

                    body.push({
                        columns: [{
                            className: 'text-center',
                            value: $.tagHtml('div', {
                                class: 'x-table-empty',
                                text: config.emptyMsg || 'No Data'
                            }),
                            attributes: {
                                colspan: header.length
                            }
                        }]
                    });
                }

                // dynamically create a table config object
                table = {
                    header: {
                        rows: [
                            {
                                columns: header
                            }
                        ]
                    },
                    body: {
                        rows: body,
                        limit: ((!config.limit || config.limit === -1) ? Infinity : config.limit)
                    }
                };

                if (config.footer) {
                    table.footer = config.footer;
                }
            }

            _.extend(table, _.pick(config, 'className'));

            if (table) {

                me.tableContainer.show(new views.TableView(table));
            }
        },
        getTooltipForHeaderColumn: function (column) {
            const me = this;
            const tooltip = column.tooltip;

            if (_.isString(tooltip)) {
                return tooltip;
            }

            if (_.isObject(tooltip)) {
                if (_.isString(tooltip.content)) {
                    return tooltip.content;
                } else if (_.isFunction(tooltip.content)) {
                    return tooltip.content();
                } else if (_.isString(tooltip.template)) {
                    return new Marionette.ItemView({
                        model: me.model,
                        template: tooltip.template
                    }).render().$el.html();
                }
            }

            return null;
        }
    });

});
